/** Checks if the passed property is an instance of MediaStreamTrack */
export default function (track): boolean {

  return track instanceof MediaStreamTrack

}
